export const actionTypes = {
  GET_SEARCH_RESULTS: 'GET_SEARCH_RESULTS',
  GET_SEARCH_RESULTS_LOADING: 'GET_SEARCH_RESULTS_LOADING',
  RESET_SEARCH_RESULTS: 'RESET_SEARCH_RESULTS',
};
